let quickShopCartArtPromise;
function loadQuickShopCartArt(content) {
  const drawer = content.querySelector('[data-cart-art-src]');
  if (!drawer || customElements.get(drawer.dataset.cartArtTag || 'sino-cart-art') || quickShopCartArtPromise) return;
  quickShopCartArtPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = drawer.dataset.cartArtSrc;
    script.async = true;
    script.onload = resolve;
    script.onerror = () => { script.remove(); reject(new Error('Cart button animation could not load')); };
    document.head.append(script);
  }).catch(() => { quickShopCartArtPromise = null; });
}

if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      // if (!opener.hasAttribute("data-product-url")){
      //   super.show(opener);
      //   return;
      // };

      const modalOpener = opener.closest('.quick-add');
      if (modalOpener) modalOpener.classList.add('quick-add--visible');
      opener.classList.add('btn--loading');
      opener.setAttribute('aria-disabled', true);
      opener.setAttribute('disabled', true);

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const quickBuyContent = responseHTML.getElementById("quick-buy-content").content;
          Array.from(quickBuyContent.querySelectorAll("noscript")).forEach((noScript) => noScript.remove());
          this.modalContent.replaceChildren(quickBuyContent);
          loadQuickShopCartArt(this.modalContent);

          const imgsElm = this.modalContent.querySelectorAll('img');

          imgsElm.forEach((imgElm) => {
            imgElm.onload = () => {
              imgElm.classList.add('loaded');
            }
          });

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          setTimeout(() => {
            super.show(opener);
          });
        })
        .finally(() => {
          if (modalOpener) modalOpener.classList.remove('quick-add--visible');
          opener.removeAttribute('aria-disabled');
          opener.removeAttribute('disabled');
          opener.classList.remove('btn--loading');
        });
    }
  });
}
